export default __webpack_public_path__ + "static/media/timeline_1.6f0617de.svg";